const CUSTOM_SWATCHES_COMPONENT = 'custom-swatches';

if (!customElements.get(CUSTOM_SWATCHES_COMPONENT)) {
  class CustomSwatches extends HTMLElement {
    #boundFilterChangeHandler = null;

    constructor() {
      super();
      this.swatchInputs = this.querySelectorAll('.js-swatch');
      this.swatchItems = this.querySelectorAll('.color-swatch-item');
    }

    connectedCallback() {
      this.initEventListeners();
      this.syncWithURLFilters();
    }

    disconnectedCallback() {
      if (this.#boundFilterChangeHandler) {
        document.removeEventListener('collection:filterChanged', this.#boundFilterChangeHandler);
      }
    }

    initEventListeners() {
      this.#boundFilterChangeHandler = this.syncWithURLFilters.bind(this);
      document.addEventListener('collection:filterChanged', this.#boundFilterChangeHandler);
    }

    syncWithURLFilters() {
      const selectedColors = this.#getSelectedColorsFromURL();

      if (!selectedColors.length) return;

      const lastSelectedColor = selectedColors[selectedColors.length - 1];
      const hasThisColor = this.#hasColor(lastSelectedColor);
      
      if (hasThisColor) {
        this.#selectColorByName(lastSelectedColor);
      }
    }

    #getSelectedColorsFromURL() {
      const urlParams = new URLSearchParams(window.location.search);
      return urlParams.getAll('filter.p.m.custom.available_colors');
    }

    #selectColorByName(colorName) {
      const normalizedColor = this.#normalizeColorName(colorName);

      for (const swatchItem of this.swatchItems) {
        const itemColorName = swatchItem.dataset.colorName;

        if (itemColorName === normalizedColor) {
          if (swatchItem.classList.contains('color-swatch-item--hidden')) {
            swatchItem.classList.remove('color-swatch-item--hidden');
          }

          const input = swatchItem.querySelector('.js-swatch');

          if (input && !input.checked) {
            setTimeout(() => {
              input.checked = true;

              const changeEvent = new Event('change', { bubbles: true });
              input.dispatchEvent(changeEvent);
            }, 100);
          }
          return;
        }
      }
    }

    #hasColor(colorName) {
      const normalizedColor = this.#normalizeColorName(colorName);
      
      for (const swatchItem of this.swatchItems) {
        const itemColorName = swatchItem.dataset.colorName;
        if (itemColorName === normalizedColor) {
          return true;
        }
      }
      return false;
    }

    #normalizeColorName(colorName) {
      return colorName
        .toLowerCase()
        .trim()
        .replace(/\s+/g, '-')
        .replace(/[^\w-]/g, '');
    }
  }

  customElements.define(CUSTOM_SWATCHES_COMPONENT, CustomSwatches);
}

